import actionCreatorFactory from "typescript-fsa";
import { Action, Dispatch } from "redux";
import StaffApi from "api/StaffApi";
import StaffRes from "types/res/staff/StaffRes";
import UpdateStaffReq from "types/req/staff/UpdateStaffReq";
import CreateStaffReq from "types/req/staff/CreateStaffReq";
import DeleteStaffReq from "types/req/staff/DeleteStaffReq";
import accountActions from "./account";

const actionCreator = actionCreatorFactory();
const addStaffAction = actionCreator.async<
  CreateStaffReq,
  StaffRes,
  { code: number; description: string }
>("ADD_STAFF");

export const addStaff =
  (companyId: number, req: CreateStaffReq) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(addStaffAction.started({ ...req }));

    try {
      const staff = new CreateStaffReq({ ...req });
      const result = await StaffApi.create(companyId, staff);
      dispatch(
        addStaffAction.done({
          params: { ...req },
          result: result as any,
        })
      );
      return result;
    } catch (error) {
      dispatch(
        addStaffAction.failed({
          params: { ...req },
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const fetchStaffAction = actionCreator.async<
  {},
  StaffRes[],
  { code: number; description: string }
>("FETCH_STAFF");

export const fetchStaff =
  (companyId: number) => async (dispatch: Dispatch<Action>) => {
    dispatch(fetchStaffAction.started([]));

    try {
      const result = await StaffApi.findAll(companyId);

      dispatch(
        fetchStaffAction.done({
          params: {},
          result: result as any,
        })
      );
      return result;
    } catch (error) {
      dispatch(
        fetchStaffAction.failed({
          params: {},
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const updateStaffAction = actionCreator.async<
  UpdateStaffReq,
  StaffRes,
  { code: number; description: string }
>("UPDATE_STAFF");

export const updateStaff =
  (companyId: number, req: UpdateStaffReq, accessToken?: string) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(updateStaffAction.started({ ...req }));

    try {
      const updateStaff = new UpdateStaffReq({ ...req });
      const result = await StaffApi.update(companyId, req.staffId, updateStaff);
      dispatch(
        updateStaffAction.done({
          params: { ...req },
          result: result as any,
        })
      );
      if (req.companyId && accessToken) {
        dispatch(
          accountActions.signinWithEmailAction.done({
            params: { email: result.email, password: "" },
            result: { accessToken, staff: result },
          })
        );
      }
      /* 🔴 2026-09-14 …ここに 在った 2 つ目の dispatch を 外しました。
       *
       * 何が 起きていたか（本番の 実測・企業切り替えの 直後）
       *   21:36:06.282 staff/update/35（企業切り替え）
       *   21:36:06.42  土台一式 …checkStaffStatus / staff/findAll /
       *                changeLog / dashboard/summary
       *   21:36:07.64  ★同じ 土台一式が もう一度★ …company/findAll /
       *                checkStaffStatus / additionalTime / notelClass /
       *                castCategory / shop …
       *   ⇒ 土台が 2 セット 走り、初回の ローディングが その分 伸びておりました。
       *
       * なぜ 外してよいか
       *   一 外した側の 条件は、残した側に 完全に 含まれます
       *     （isForceSite が 真なら req.companyId && accessToken も 必ず 真）
       *   二 渡している 値が 1 字も 違いません
       *   三 受ける reducer は return payload.result …前の状態を 使わず
       *     置き換えるだけ ⇒ 2 度 同じ値を 入れても 結果は 同じ
       *   ⇒ 消しても 状態は 変わりません。走る本数だけが 減ります。
       *
       * ⚠️ 新しい版（staff-app）にも 同じ直しを 入れております。
       */
      return result;
    } catch (error) {
      dispatch(
        updateStaffAction.failed({
          params: { ...req },
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const deleteStaffAction = actionCreator.async<
  DeleteStaffReq,
  {},
  { code: number; description: string }
>("DELETE_STAFF");

export const deleteStaff =
  (companyId: number, req: DeleteStaffReq) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(deleteStaffAction.started({ ...req }));

    try {
      const staff = new DeleteStaffReq({ ...req });
      const result = await StaffApi.delete(companyId, staff);
      dispatch(
        deleteStaffAction.done({
          params: { ...req },
          result: {},
        })
      );
      return result;
    } catch (error) {
      dispatch(
        deleteStaffAction.failed({
          params: { ...req },
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const staffActions = {
  fetchStaffAction,
  addStaffAction,
  updateStaffAction,
  deleteStaffAction,
};

export default staffActions;
